import * as Yup from "yup";
import { I_OwnersForm } from "./util/for.util";
import { CRegexp } from "../../../model/const/regexp/regexp.const";
import extractRequiredFields from "../../../helpers/extract-required-fields";
import { I_GENERIC_ITEMS } from "../../../model/interface/items.interface";
import { C_IDENTIFICATION } from "../../../model/const/indetification.const";

export type TFields = keyof I_OwnersForm;

type TfieldsG = {
  [K in TFields]: any;
};

const fields: any = {
  birthdate: Yup.string().required("La fecha de nacimiento es requerida").nullable(),
  identification_type: Yup.array()
    .min(1, "Especifique el tipo de documento")
    .required("El campo es requerido")
    .nullable(),
  number_identification: Yup.string()
    .when("identification_type", {
      is: (identification_type: I_GENERIC_ITEMS[]) => {
        return identification_type[0].value === C_IDENTIFICATION.CEDULA.value;
      },
      then: () =>
        Yup.string()
          .matches(CRegexp.ID, "La identificación invalida")
          .required("La identificación es requerida")
          .nullable(),
      otherwise: () =>
        Yup.string()
          .matches(CRegexp.PASSPORT, "El pasaporte no es valido")
          .required("El pasaporte es requerido")
          .nullable()
    })
    .required("La identificación es requerida")
    .nullable(),
  name: Yup.string().required("El nombre es requerido").nullable(),
  country: Yup.array()
    .min(1, "El país es requerido")
    .required("El país es requerido")
    .nullable(),
  city: Yup.string().required("La ciudad es requerida").nullable(),
  sector: Yup.string().nullable(),
  address: Yup.string().required("La dirección es requerida").nullable(),
  mobile_phone: Yup.string().required("El teléfono móvil es requerido").nullable(),
  email: Yup.string().required("El correo electrónico es requerido").nullable(),
  company_phone: Yup.string().nullable(),
  fax: Yup.string().nullable(),
  company: Yup.string().nullable(),
  company_occupation: Yup.string().nullable(),
  company_identification: Yup.string()
    .nullable()
    .matches(/^\d{9}$/, "El RNC consta de 9 dígitos"),
  company_email: Yup.string().nullable(),
  company_registration_comercial: Yup.string().nullable(),
  company_fax: Yup.string().nullable(),
  phone: Yup.string().required("El teléfono de oficina es requerido"),
  has_company: Yup.array()
    .min(1, "Especifique si tiene una empresa.")
    .required("El campo es requerido")
    .nullable(),
  residential_phone: Yup.string().nullable(),
  is_conflictive: Yup.number()
};

export const createOwnersValidation = Yup.object().shape({
  ...fields
});

export const fieldRequired: Record<string, boolean> = extractRequiredFields(
  createOwnersValidation
) as Record<string, boolean>;
